import CardMedia from '@mui/material/CardMedia';
import { trackVideoPlayback } from '../../../helpers/analytics';

export const IntroVideo = ({
  roundedCorners = false,
}: {
  roundedCorners?: boolean;
}) => {
  const videoSrc =
    process.env.APP_ENV !== 'prod'
      ? 'https://app-assets.staging.talkiatry.com/media/intake_intro_video_7.24.23.mp4'
      : 'https://app-assets.talkiatry.com/media/intake_intro_video_7.24.23.mp4';

  const thumbnail =
    process.env.APP_ENV !== 'prod'
      ? 'https://app-assets.staging.talkiatry.com/media/intake_intro_thumbnail_7.24.23.png'
      : 'https://app-assets.talkiatry.com/media/intake_intro_thumbnail_7.24.23.png';

  return (
    <CardMedia
      component="video"
      title="Get to know Talkiatry"
      controls
      sx={{ borderRadius: roundedCorners ? 2 : 0 }}
      poster={thumbnail}
      onLoadStart={() => trackVideoPlayback('loading')}
      onLoadedData={() => trackVideoPlayback('loaded')}
      onPlay={() => trackVideoPlayback('play')}
      onPause={() => trackVideoPlayback('pause')}
      onEnded={() => trackVideoPlayback('ended')}
      onError={() => trackVideoPlayback('error')}
    >
      <source src={videoSrc} type="video/mp4" /> Your browser does not support
      the video tag.
    </CardMedia>
  );
};
